import { Button, Result } from 'antd';
import './style.css';

export default function PageNotFound() {
    return (
        <div className="relative w-full h-screen bg-[#308595] bg-custom">
            <div className="flex flex-col items-center justify-center h-full">
                {/* <div className="border bg-white border-slate-200 rounded-[10px] flex flex-col items-center justify-center p-8">
                    <h2 className='text-[4em]'>404</h2>
                    <p className=''>Page Not Found</p>
                    <h3 className='text-[1.5em]'>The page you are looking for is not found</h3>
                </div> */}
                <Result
                    status="404"
                    title="404"
                    subTitle="Sorry, the page you visited does not exist."
                    extra={<Button type="primary">Back Home</Button>}
                />
            </div>
        </div>
    )
}